import type { ComboboxItem } from '@mantine/core';
import type { ProjectsResponse } from '../../../../api/projects-client/projects-client.type';

/**
 * Transforms projects/teams data into Mantine Combobox format,
 * sorted alphabetically and filtered by search term
 *
 * @param {ProjectsResponse[]} projects - Array of projects/teams
 * @param {string} searchTerm - Search term to filter results
 * @returns {ComboboxItem[]} Formatted data for Mantine Combobox
 */
const getTeamOptions = (teams: ProjectsResponse[], searchTerm = ''): ComboboxItem[] => {
  const lowerSearch = searchTerm.toLowerCase();

  return teams
    .filter((team) => team.name.toLowerCase().includes(lowerSearch))
    .sort((a, b) => a.name.localeCompare(b.name))
    .map((team) => ({
      value: team.id,
      label: team.name,
    }));
};

export { getTeamOptions };
